export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const storeToken = (token) => {
    localStorage.setItem('authTokenTemplate', token);
}

export const removeToken = () => {
    localStorage.removeItem('authTokenTemplate');
}

export const getToken = () => {
    return localStorage.getItem('authTokenTemplate');
}

export const generateColorFromId = (id) => {
    let hash = 0;
    for (let i = 0; i < id.length; i++) {
        hash = (hash << 5) - hash + id.charCodeAt(i);
    }
    const color = Math.abs(hash % 360);
    return `hsl(${color}, 70%, 60%)`;
};

export const getCurrentMonth = () => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
};